import { RadioButtonWithLabelOption } from '@tableau/widgets';
import React from 'react';

import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { SessionServerSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { useSelector } from '~src/settings/general-settings/utils';

import { Messages } from '../../../../../codegen/Localize';
import { FormikRadioButtonGroup } from '../../../../../commonInfra/components/FormikRadioButtonGroup';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import { settingsRadioButtonItemHeight } from '../../../../styles/CommonStyles';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
import { SiteSettingsForSiteAdminProps } from '../../site-settings/ReactSiteSettingsForSiteAdmin';

export const BLOCK_NON_EXTRACT_FIELD = 'settings.blockNonExtractEnabled';
export const BLOCK_NON_EXTRACT_SECTION_TEST_ID = 'block-non-extract-site-setting';
export const BLOCK_NON_EXTRACT_ENABLE_BUTTON_TEST_ID = 'block-non-extract-enable';
export const BLOCK_NON_EXTRACT_DISABLE_BUTTON_TEST_ID = 'block-non-extract-disable';

export type BlockNonExtractSectionProps = SiteSettingsForSiteAdminProps<'blockNonExtractEnabled'>;

function getButtonsList(): RadioButtonWithLabelOption<boolean>[] {
  return [
    {
      value: true,
      label: Messages.BlockNonExtractSiteSettingEnabled(),
      detail: Messages.BlockNonExtractSiteSettingEnabledDescription(),
      testId: BLOCK_NON_EXTRACT_ENABLE_BUTTON_TEST_ID
    },
    {
      value: false,
      label: Messages.BlockNonExtractSiteSettingDisabled(),
      detail: Messages.BlockNonExtractSiteSettingDisabledDescription(),
      testId: BLOCK_NON_EXTRACT_DISABLE_BUTTON_TEST_ID
    }
  ];
}

export function BlockNonExtractSection(props: BlockNonExtractSectionProps) {

  const buttons = React.useMemo(() => getButtonsList(), []);

  return !useShowSettingsSection() ? null: (
    <SettingsSection title={Messages.BlockNonExtractSiteSettingTitle()}
      testId={BLOCK_NON_EXTRACT_SECTION_TEST_ID}>

      <FormikRadioButtonGroup
        buttonList={buttons}
        className={settingsRadioButtonItemHeight}
        name={BLOCK_NON_EXTRACT_FIELD}
        aria-label={Messages.BlockNonExtractSiteSettingTitle()}
      />
    </SettingsSection>
  );
}

function useShowSettingsSection(): boolean {
  const isOnlineEnvironment = useSelector(SessionServerSelectors.isOnlineEnvironment);
  return FeatureFlags.blockNonExtractSiteControlEnabled && isOnlineEnvironment;
}

export const BlockNonExtractSectionSpecs = componentRegistryEntry({
  name: 'BlockNonExtractSection',
  component: BlockNonExtractSection
});

